import React from "react"
import PropTypes from "prop-types"
import { Typography } from "antd"
import { CalendarOutlined, ClockCircleOutlined } from "@ant-design/icons"
import styles from "./BookingForm.module.css"
import moment from "moment"

const { Text } = Typography

const MetaItem = ({ icon: Icon, text }) => (
  <div className={styles.tripMetaItem}>
    <Icon className={styles.tripMetaIcon} />
    <Text className={styles.tripMetaText}>{text}</Text>
  </div>
)

MetaItem.propTypes = {
  icon: PropTypes.elementType.isRequired,
  text: PropTypes.string.isRequired
}

const TripDetailsCard = ({ booking, bookingSelections, experienceDetail }) => {
  // Prefer the currently selected experience (experienceDetail) over the booking's original trip, so
  // that switching the experience while editing shows the updated details here rather than the old
  // one. Falls back to the booking when the detail hasn't loaded / for unchanged bookings.
  const tripName = experienceDetail?.title || booking?.trip?.title || ""
  const isMultiDay = (experienceDetail?.duration_type || booking?.duration_type) === "multi_day"

  let dateText = ""
  let timeText = ""

  if (isMultiDay) {
    const numDays = booking?.booked_dates?.length || 1
    if (bookingSelections?.date) {
      const startDate = moment(bookingSelections.date)
      const endDate = moment(bookingSelections.date).add(numDays - 1, "days")
      const formattedStart = startDate.format("MM/DD/YYYY")
      const formattedEnd = endDate.format("MM/DD/YYYY")
      dateText = numDays > 1 ? `${formattedStart} → ${formattedEnd}` : formattedStart
    }
    timeText = bookingSelections?.timeSlot?.split(" - ")?.[0] || booking?.start_time || ""
  } else {
    dateText = bookingSelections?.date ? moment(bookingSelections.date).format("MM-DD-YYYY") : ""
    timeText = bookingSelections?.timeSlot || ""
  }

  if (!tripName && !dateText && !timeText) return null

  return (
    <>
      {tripName && <div className={styles.tripName}>{tripName}</div>}
      {(dateText || timeText) && (
        <div className={styles.tripMetaRow}>
          {dateText && <MetaItem icon={CalendarOutlined} text={dateText} />}
          {timeText && <MetaItem icon={ClockCircleOutlined} text={timeText} />}
        </div>
      )}
    </>
  )
}

TripDetailsCard.propTypes = {
  booking: PropTypes.object,
  bookingSelections: PropTypes.object,
  experienceDetail: PropTypes.object
}

export default TripDetailsCard
